module.exports = __webpack_public_path__ + "static/media/galeryGrass5.cf571696.jpg";